import React from 'react';

const services = [
  {
    title: 'Software Development',
    text: 'Web, mobile and cloud-based application development designed around practical business needs.',
  },
  {
    title: 'AI and Automation',
    text: 'Practical AI, automation and data-driven workflows focused on operational value.',
  },
  {
    title: 'Product Delivery',
    text: 'Development support for MVPs, digital platforms, enhancements and product rollouts.',
  },
  {
    title: 'Technical Support',
    text: 'Ongoing maintenance, improvements and operational support for delivered systems.',
  },
];

export default function Services() {
  return (
    <section id="services" className="section">
      <div className="section-heading">
        <p className="eyebrow">What We Do</p>
        <h2>Practical technology delivery.</h2>
        <p>
          We help organisations build, improve and support digital platforms with a clear focus
          on execution and business value.
        </p>
      </div>

      <div className="cards">
        {services.map((service) => (
          <article className="card" key={service.title}>
            <div className="accent" />
            <h3>{service.title}</h3>
            <p>{service.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}